export class Disclaimer {
    public Id: number = -1;
    public Version: number = -1;
    public Text: string = "";
    public Description: string = "";
    public ReadOnly: boolean = true;
    public DisclaimerType: number = -1; //  NewClient = 1, SkinTypeOverride = 2, SafetyOverride = 4, General = 8, OnlineClientRegistration = 16 
    public ForcePrintAndSign: boolean = false;
    public VerbalAcceptance: boolean = true;
    public FingerprintAcceptance: boolean = false;
    public OnlineSignatureAcceptance: boolean = false;
    public DisclaimerValidOnlyOnce: boolean = true;
    public DisclaimerDaysValidFor: number = 28;
    public File: string;
    public FileName: string;

    public static CreateFrom(s: Disclaimer): Disclaimer {
        var t: Disclaimer = new Disclaimer();
        t.Id = s.Id;
        t.Version = s.Version;
        t.Text = s.Text;
        t.Description = s.Description;
        t.ReadOnly = s.ReadOnly;
        t.DisclaimerType = s.DisclaimerType; //  NewClient = 1, SkinTypeOverride = 2, SafetyOverride = 4, General = 8, OnlineClientRegistration = 16
        t.ForcePrintAndSign = s.ForcePrintAndSign;
        t.VerbalAcceptance = s.VerbalAcceptance;
        t.FingerprintAcceptance = s.FingerprintAcceptance;
        t.OnlineSignatureAcceptance = s.OnlineSignatureAcceptance;
        t.DisclaimerValidOnlyOnce = s.DisclaimerValidOnlyOnce;
        t.DisclaimerDaysValidFor = s.DisclaimerDaysValidFor;
        t.File = s.File;
        t.FileName = s.FileName;
        return t;
    }
}